import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../supabaseClient';
import TradeResourceCard from './TradeResourceCard';

const NAVY_MID  = '#132233';
const WHITE     = '#FFFFFF';
const FONT_HEAD = "'Bebas Neue', sans-serif";
const FONT_BODY = "'DM Sans', sans-serif";

// Reference grid for the 9 trades tracked in trade_resources -- distinct from
// ResourceFinder (which lists specific schools/unions to contact), this shows
// general facts about each trade itself (typical apprenticeship length, pay,
// required certs, career path).
// onViewTradeHub: optional -- forwarded to each TradeResourceCard so its "View full trade
// guide" link only appears when the parent actually supports opening the Trade Hub.
export default function LicensingCerts({ onViewTradeHub }) {
  const { t } = useTranslation();
  const [trades, setTrades]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase
        .from('trade_resources')
        .select('*')
        .eq('is_active', true)
        .order('trade_name', { ascending: true });
      if (cancelled) return;
      setTrades(error ? [] : (data || []));
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  const filtered = trades.filter(t => {
    const q = search.toLowerCase();
    if (!q) return true;
    return t.trade_name.toLowerCase().includes(q) || (t.category || '').toLowerCase().includes(q);
  });

  return (
    <div>
      <h1 style={{ fontFamily: FONT_HEAD, fontSize: '1.7rem', color: WHITE, letterSpacing: '0.04em', marginBottom: '6px' }}>
        {t('resources.licensing.title')}
      </h1>
      <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.45)', lineHeight: 1.5, marginBottom: '16px', maxWidth: '640px' }}>
        {t('resources.licensing.subtitle')}
      </p>

      <input
        placeholder={t('resources.licensing.searchPlaceholder')}
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{
          width: '100%', maxWidth: '320px', padding: '9px 12px', fontSize: '0.84rem',
          backgroundColor: NAVY_MID, border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: '8px', color: WHITE, outline: 'none', fontFamily: FONT_BODY,
          marginBottom: '16px', display: 'block',
        }}
      />

      {!loading && (
        <p style={{ fontSize: '0.7rem', fontWeight: 700, color: 'rgba(255,255,255,0.25)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '12px' }}>
          {t('resources.licensing.tradeCount', { count: filtered.length })}
        </p>
      )}

      <div className="trade-resource-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', alignItems: 'stretch', gap: '12px' }}>
        {loading && (
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '2.5rem 0', color: 'rgba(255,255,255,0.3)', fontSize: '0.9rem' }}>
            {t('common.loading')}
          </div>
        )}
        {!loading && filtered.length === 0 && (
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '2.5rem 0', color: 'rgba(255,255,255,0.3)', fontSize: '0.9rem' }}>
            {t('resources.noTradesMatch')}
          </div>
        )}
        {!loading && filtered.map(t => (
          <TradeResourceCard key={t.id} trade={t} onViewTradeHub={onViewTradeHub} compact />
        ))}
      </div>
    </div>
  );
}
